import { NgModule } from '@angular/core';
import { ToastrModule } from 'ngx-toastr';

import { SaysuaToasterService } from './toaster.service';

@NgModule({
  imports: [ToastrModule],
  providers: [SaysuaToasterService],
})
export class SaysuaToasterModule {}